import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-bank-deposit',
  templateUrl: './bank-deposit.component.html',
  styleUrls: ['./bank-deposit.component.css'],
})
export class BankDepositComponent implements OnInit {
  public cuentaAhorroBancolombia: string;
  public convenioBancolombia: string;
  public cuentaCorrienteItau: string;
  public convenioItau: string;
  public cuentaDavivienda: string;

  constructor(private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) private data: any) {}

  ngOnInit() {
    this.cuentaAhorroBancolombia = this.data.cuentaBancolombia.value;
    this.convenioBancolombia = this.data.convenioBancolombia.value;
    this.cuentaCorrienteItau = this.data.cuentaItau.value;
    this.convenioItau = this.data.convenioItau.value;
    this.cuentaDavivienda = this.data.cuentaDavivienda.value;
  }

  public closedModal() {
    this.dialog.closeAll();
  }
}
